// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.empty-letter[data-v-c3220d84] {\n  position: absolute;\n  bottom: 0;\n}\nfooter[data-v-c3220d84] {\n  position: fixed;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  left: 0;\n  bottom: 0; /* Левый нижний угол */\n  padding: 10px;\n  /*background: #39b54a;  Цвет фона */\n  width: 100%; /* Ширина слоя */\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}", ""]);
// Exports
module.exports = exports;
